"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    breadcrumbDividerClassNames: function() {
        return breadcrumbDividerClassNames;
    },
    useBreadcrumbDividerStyles_unstable: function() {
        return useBreadcrumbDividerStyles_unstable;
    }
});
const _react = require("@griffel/react");
const breadcrumbDividerClassNames = {
    root: 'fui-BreadcrumbDivider'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__resetStyles)("rk008qs", null, [
    ".rk008qs{display:flex;}"
]);
const useIconStyles = /*#__PURE__*/ (0, _react.__styles)({
    small: {
        Be2twd7: "f1ugzwwg"
    },
    medium: {
        Be2twd7: "f4ybsrx"
    },
    large: {
        Be2twd7: "fe5j1ua"
    }
}, {
    d: [
        ".f1ugzwwg{font-size:12px;}",
        ".f4ybsrx{font-size:16px;}",
        ".fe5j1ua{font-size:20px;}"
    ]
});
const useBreadcrumbDividerStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    const iconStyles = useIconStyles();
    const { size = 'medium' } = state;
    state.root.className = (0, _react.mergeClasses)(breadcrumbDividerClassNames.root, styles, iconStyles[size], state.root.className);
    return state;
};
